import { components } from "@certn/api/generated-schemas/applicant-portal";
import { createContext } from "react";

export const FitnessProprietyLayoutContext = createContext<{
  sectionLabel?: string;
  subLabel?: string;
  templateData?: {
    templates: readonly components["schemas"]["FitnessProprietyTemplate"][];
  };
  apiError?: Error;
}>({});
